const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: false,
    width: 20,
  },
  {
    key: 'vgroups',
    label: 'report.fields.vehicleGroup',
    header: 'vgroups',
    filter: false,
    width: 20,
  },
  {
    key: 'deviceType',
    label: 'report.fields.deviceType',
    header: 'deviceType',
    filter: false,
    width: 20,
  },
  {
    key: 'totalMoving',
    label: 'report.fields.movingDistance',
    header: 'totalMoving',
    filter: false,
    width: 10,
  },
  // {
  //   key: 'totalAssisted',
  //   label: 'report.fields.assistedDistance',
  //   header: 'total_assisted',
  //   filter: false,
  //   width: 10,
  // },
  {
    key: 'totalHourMovingFormatted',
    label: 'report.fields.movingDuration',
    header: 'totalHourMoving',
    filter: false,
    width: 10,
  },
  // {
  //   key: 'totalHourAssistedFormatted',
  //   label: 'report.fields.assistedDuration',
  //   header: 'total_hour_assisted',
  //   filter: false,
  //   width: 10,
  // },
  {
    key: 'totalTimeTripStopFormatted',
    label: 'report.fields.stopDuration',
    header: 'totalHourTripStop',
    filter: false,
    width: 10,
  },
  {
    key: 'averageSpeed',
    label: 'report.fields.averageSpeed',
    header: 'averageSpeed',
    filter: false,
    width: 10,
  },
]
export default fields
